import { isEmpty, isNil, isArray } from 'lodash';
import MsgUtil from '@/utils/message';
import TreeApi from '@/api/common/tree';

/**
 * 동적 관리 대상 트리용 믹스인
 * @/mixins/tree/dynamic-tree와 함께 사용해야한다.
 * @type {Object}
 */
export default {
  methods: {
    /**
     * 하위 노드 정보를 설정한다.
     * @author Ju
     * @param  {[type]} resolve [description]
     * @param  {[type]} data    [description]
     */
    setChildren(resolve, data, params) {
      const children = isArray(data) ? data : [data];
      this.setEventStatusToNodeDatas(children);

      resolve(children);

      this.$nextTick(() => {
        if (!isEmpty(children)) {
          const tree = this.$refs[this.treeRef];
          this.createChildNodes(children, tree);
          if ((!isNil(this.searchKeyword) && this.searchKeyword !== '') || !isNil(params.targetObjId)) {
            this.setLoadedStatusToAllTreeNodes();
          }
        }
        this.callbackLoadRouteNode();
        if (!isNil(params.targetObjId)) {
          this.$emit('filter-obj', this.selectedNode);
        }
      });
    },
    /**
     * 검색 키워드 기준으로 트리 데이터를 로드한다.
     * TODO: 현재는 기준정보에 따라 검색 결과 개수 제한이 있는 경우 검색되는 관리 대상 개수를 확인하는 요청을 먼저 보내
     * 검색 결과 제한 개수를 넘는 경우 검색을 수행하지 안흔 구조로 되어있음. 검색 가능한 경우는 검색 대상 개수 파악
     * / 실제 검색 트리 데이터 조회 2번의 요청이 가는 구조이므로, 가능한 경우 트리 데이터 조회하는 요청을 통해 처리 필요.
     * 하나의 요청으로 처리하는 것은 간단하나 기존 트리 데이터를 유지하고 검색이 가능한 경우에만 검색 결과 트리
     * 데이터로 변경해도록 vue에서 처리되어야함.
     * @author Ju
     * @param  {String} keyword 검색 키워드
     */
    filterTree(keyword) {
      if (isNil(keyword) || keyword === '') {
        this.searchKeyword = keyword;
        this.reloadRootNode();
      } else {
        TreeApi.getTreeSearchObjNodeCount(keyword, this.treeType)
          .then((response) => {
            if (response.data.success) {
              this.searchKeyword = keyword;
              this.reloadRootNode();
            } else {
              this.showSearchFailMessage(response.data);
            }
          })
          .catch((e) => {
            this.showSearchFailMessage(e);
            throw new Error(e);
          });
      }
    },
    /**
     * 검색 실패 시 적절한 메시지를 제공한다.
     * @author Ju
     * @param  {Object} data 응답 데이터
     */
    showSearchFailMessage(data) {
      if (!isNil(data) && data.message !== '') {
        this.$emit('show-message', data.message);
      } else {
        this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '장비 트리 정보', false));
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/tree/TargetTree/mixins/dynamic-tree.js